<template>
  <v-checkbox
      v-show="!hide"
      :color="color ? color : 'primary'"
      v-model="checkboxValue"
      :tabindex="tabIndex"
      @change="changeValue"
      :disabled="disabled"
  >
    <template v-slot:label>
      <div>
        <span class="mr-1 center-checkbox-text">
          {{ label }}
        </span>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on">help_outline</v-icon>
          </template>
          <p class="ma-0" v-if="tooltipLine1">{{ tooltipLine1 }}</p>
          <p class="ma-0" v-if="tooltipLine2">{{ tooltipLine2 }}</p>
        </v-tooltip>
      </div>
    </template>
  </v-checkbox>
</template>

<script>
export default {
  name: "CheckboxTooltipHint",
  props: {
    hide: Boolean,
    color: String,
    label: String,
    tooltipLine1: String,
    tooltipLine2: String,
    tabIndex: String,
    disabled: Boolean
  },
  data() {
    return {
      checkboxValue: false
    }
  },
  methods: {
    changeValue() {
      this.$emit('updateCheckbox', this.checkboxValue);
    },
    setValue(value) {
      this.checkboxValue = value;
      this.changeValue();
    }
  }
}
</script>

<style scoped>
.center-checkbox-text {
  display: inline-block;
  vertical-align: middle;
}
</style>